import { createApiClient } from '@dru/api-client';

/**
 * One client for the app.
 *
 * Same-origin `/api/v1` by default — through the Vite proxy in development,
 * through a reverse proxy in production — so the HttpOnly refresh cookie
 * behaves identically in both. A cross-origin setup that exists only in one of
 * them is how SameSite surprises get discovered after deploy.
 *
 * `VITE_API_BASE` overrides it for the split-origin deployment docs/17
 * describes (`employee.drultimate.com` talking to `api.drultimate.com`). It was
 * hardcoded, so a production build emitted same-origin requests and only
 * worked behind a proxy that is not in this repository. Set it at build time:
 *
 *   VITE_API_BASE=https://api.drultimate.com/api/v1 pnpm build
 *
 * That deployment also needs the app's origin listed in the API's
 * CORS_ORIGINS, since every request is credentialed and a wildcard is not
 * allowed with credentials.
 *
 * The refresh cookie survives it: SameSite is about the SITE, not the origin,
 * and `employee.drultimate.com` and `api.drultimate.com` share the registrable
 * domain — so `SameSite=strict` still sends it. What it does require is
 * `Secure`, which the API sets when NODE_ENV is production, and therefore
 * HTTPS on both hosts.
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api/v1';
export const api = createApiClient(API_BASE);
